import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

import { BREAKPOINTS } from '../../lib/constants';

export const BookingAsideContainer = styled.aside`
  padding: ${fromTheme('spacing_medium')};

  @media screen and (max-width: ${BREAKPOINTS.small}px) {
    padding: ${fromTheme('spacing_small')};
  }

  @media screen and (max-width: ${BREAKPOINTS.large - 1}px) {
    display: none;
  }

  @media screen and (min-width: ${BREAKPOINTS.large}px) {
    display: block;
    margin-bottom: ${fromTheme('spacing_large')};
    background: ${fromTheme('color_background')};
    border-radius: ${(props) =>
      fromTheme('provider_profile_border_radius')(props)};
    border-width: ${(props) =>
      fromTheme('provider_profile_border_width')(props) ||
      fromTheme('border_width')(props)};
    border-style: ${(props) =>
      fromTheme('provider_profile_border_style')(props)};
    border-color: ${(props) =>
      fromTheme('provider_profile_color_border')(props)};
    box-shadow: ${(props) => fromTheme('provider_profile_box_shadow')(props)};
    -webkit-box-shadow: ${(props) =>
      fromTheme('provider_profile_box_shadow')(props)};
    -moz-box-shadow: ${(props) =>
      fromTheme('provider_profile_box_shadow')(props)};
  }

  @media print {
    display: none;
  }
`;

interface BookingSectionContainerProps {
  showBorder?: boolean;
}

export const BookingSectionContainer = styled.section<BookingSectionContainerProps>`
  padding: ${fromTheme('spacing_medium')};

  @media print {
    display: none;
  }

  @media screen and (min-width: ${BREAKPOINTS.large}px) {
    display: block;
    margin-bottom: ${fromTheme('spacing_large')};
  }

  ${(props) =>
    props.showBorder &&
    `
    background: ${fromTheme('color_background')(props)};
    border-radius: ${fromTheme('provider_profile_border_radius')(props)};
    border-width: ${
      fromTheme('provider_profile_border_width')(props) ||
      fromTheme('border_width')(props)
    };
    border-style: ${fromTheme('provider_profile_border_style')(props)};
    border-color: ${fromTheme('provider_profile_color_border')(props)};
    box-shadow: ${fromTheme('provider_profile_box_shadow')(props)};
    -webkit-box-shadow: ${fromTheme('provider_profile_box_shadow')(props)};
    -moz-box-shadow: ${fromTheme('provider_profile_box_shadow')(props)};
    `}
`;

export const BookingHeader = styled('h2')`
  margin: 0 0 ${fromTheme('spacing_medium')} 0;
  font-size: ${fromTheme('font_size_heading_4')};
  font-weight: ${fromTheme('font_weight_bolder')};
  color: ${fromTheme('color_text')};
`;

export const BookingButtonModeBookingContent = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  padding: ${fromTheme('spacing_xsmall')} 0;

  @media screen and (min-width: ${BREAKPOINTS.large}px) {
    display: block;
  }
`;

export const AvailabilityModeBookingContent = styled('div')`
  display: block;
`;

export const BookingButtonWrapper = styled('div')`
  flex: 0 1 50%;

  button.provider-booking-button,
  a.provider-booking-button {
    white-space: nowrap;
    width: 100%;
    margin-bottom: ${fromTheme('spacing_medium')};

    > span.button-text {
      font-size: ${fromTheme('font_size_heading_4')};
    }

    // add white border if screen less than large width
    @media screen and (max-width: ${BREAKPOINTS.large}px) {
      border: 1px solid white;
      margin: 0 0 0 ${fromTheme('spacing_small')};
      width: calc(100% - ${fromTheme('spacing_small')});
    }
  }
`;

export const AvailableWithinDaysText = styled('div')`
  text-align: center;
  font-size: ${fromTheme('font_size')};
  color: ${fromTheme('color_text')};
  white-space: nowrap;

  @media screen and (max-width: ${BREAKPOINTS.large}px) {
    margin-top: ${fromTheme('spacing_small')};
  }

  svg {
    display: none;
  }

  span {
    vertical-align: middle;
  }

  @media screen and (min-width: ${BREAKPOINTS.large}px) {
    font-size: ${fromTheme('font_size_small')};
    margin-bottom: ${fromTheme('spacing_small')};
    svg {
      display: inline;
      vertical-align: middle;
      color: ${fromTheme('color_icon_green')};
      margin-right: ${fromTheme('spacing_xsmall')};
    }
  }
`;

export const LoadingCard = styled('div')`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  background-color: inherit;

  > div {
    margin-bottom: ${fromTheme('spacing_medium')};
  }
`;

export const LoadingBookingOptionsMessage = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;

export const StyledScheduleAppointmentFixedMobileFooter = styled.div`
  // displayed as fixed footer on mobile screens
  width: 100%;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-top-width: ${(props) =>
    fromTheme('provider_profile_border_width')(props) ||
    fromTheme('border_width')(props)};
  border-top-style: ${(props) =>
    fromTheme('provider_profile_border_style')(props)};
  border-top-color: ${(props) =>
    fromTheme('provider_profile_color_border')(props)};
  box-shadow: ${(props) => fromTheme('provider_profile_box_shadow')(props)};

  @media screen and (min-width: ${BREAKPOINTS.large}px) {
    display: none;
  }
`;

export const StyledScheduleAppointmentAside = styled.div`
  grid-area: action;
`;
